import { environment } from './environments/environment';


export function getBoolVal(val: any, defaultVal: boolean) {
  if (typeof val === 'boolean') {
    return val;
  }

  if (val === undefined || val === null) {
    return defaultVal;
  }

  return val.toString().toLowerCase() === 'true';
}

export const env = {
  USING_ANGULAR_PROXY: getBoolVal(
    environment['USING_ANGULAR_PROXY'],
    location.href.includes('http://localhost:')
  ),

};